import { Component } from '@angular/core';
import { TranslateService } from 'ng2-translate';
import { NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
declare let $: any;

@Component({
  selector: 'app-organeria',
  templateUrl: './organeria.component.html'
})
export class OrganeriaComponent  {
  constructor( private translate:TranslateService, public modalService: NgbModal  ){

  }

  open(content) {
    this.modalService.open(content).result.then((result) => {

    }, (reason) => {

    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

}



// WEBPACK FOOTER //
// /Users/administrador/Trabajos/pascal3/src/app/components/organeria/organeria.component.ts